import _ from 'underscore'

const authHost = window.location.protocol + "//" + window.location.hostname + '/auth'

export default _.extend({}, {
  AUTH_HOST: authHost,
  AUTH_LOGIN_PAGE_URL: `${authHost}/#/connect/login`,
  AUTH_WECHAT_AUTHORITY_URL: `${authHost}/connect/wechat/bind`,
})
